import { Box } from '@material-ui/core';
import Modal from 'components/ui/modal';
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/common/Button';
import { useHistory } from 'react-router-dom';
import { toUserTimezone } from 'utils';


const useStyles = makeStyles((theme) => ({

}));

function ProgramEndModal({ setShowModal, student }) {
    const classes = useStyles();
    const history = useHistory();
    return (
        <>
            <Modal
                fullWidth
                title={`Your subscription has expired on ${toUserTimezone(student.subscriptions[0].end_date).format(
                    'MMMM D, YYYY',
                )}. please Upgrade and renew your program. `}
                open
                maxWidth="sm"
                color='primary'
                padding={1}
            >
                <Box>
                    <Box>
                        <IconButton
                            onClick={() => setShowModal(false)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                            }}
                        >

                            <CloseIcon />
                        </IconButton>

                    </Box>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <Box>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                size="large"
                                onClick={() => history.push('/addons')}>

                                Upgrade
                            </Button>

                        </Box>
                    </Box>
                </Box>
            </Modal>
        </>
    );
}

export default ProgramEndModal
